import React from "react";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import UniversalLineChartComponent from "../../../../Universal/UniversalLineChartComponent";
import "../../../../../styles/Pages/Financial/Accountant/Expenses/ExpensesLineChart.style.css";

const ExpensesLineChart = ({ graphData }) => {
  console.log("ExpensesLineChart graphData:", graphData);


  return (
    <div className="expensesLineChartComponent">
      <div className="graphHeader">
        <h3>Main stream expenses</h3>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <UniversalLineChartComponent
          data={graphData}
          lines={[
            {
              dataKey: "expenses",
              name: "Expenses",
              stroke: "#FF5733",
            },
          ]}
          xAxisKey="name"
          referenceLinesStep={1000}
        />
      </div>
    </div>
  );
};

export default ExpensesLineChart;
